import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { formatDateTimeToFrCh } from 'src/app/_helpers/utils';
import { getCancellationFlowHistoryLabel } from 'src/app/enums/cancellation/cancellation-history-status.enum';
import { describeChange } from 'src/app/shared/components/cancellation-details/cancellation-log-change';

import { TaskLogRow } from './task-log-table/task-log-table.component';

type CancellationRow = Extract<TaskLogRow, { kind: 'cancellation' }>;

/** What a cancellation's log entry edited, one field a line, under the diff modal's header. */
@Component({
  selector: 'app-task-log-cancellation-changes-modal',
  standalone: true,
  imports: [NgbModalModule],
  template: `
    <ng-template #changesModal let-modal>
      @if (row) {
        <div class="task-log-diff-modal">
          <div class="task-log-diff-modal__header">
            <div>
              <div class="task-log-diff-modal__title" i18n>Historique</div>
              <div class="task-log-diff-modal__subtitle">
                {{ statusLabel(row.status) }} -
                {{ formatDate(row.updatedOn) ?? '-' }} -
                <ng-container i18n>Par</ng-container>
                {{
                  row.updatedByFullName?.trim() ||
                    row.endedByFullName?.trim() ||
                    '-'
                }}
              </div>
            </div>
            <button
              class="lty-btn lty-btn-white"
              type="button"
              (click)="modal.close()"
              i18n
            >
              Fermer
            </button>
          </div>
          <div class="task-log-diff-modal__body">
            @for (change of row.changes; track $index) {
              <div>{{ describe(change) }}</div>
            }
          </div>
        </div>
      }
    </ng-template>
  `,
  styleUrl: './task-log-diff-modal/task-log-diff-modal.component.css',
})
export class TaskLogCancellationChangesModalComponent {
  private readonly modalService = inject(NgbModal);

  @ViewChild('changesModal')
  private readonly template?: TemplateRef<unknown>;

  protected row: CancellationRow | null = null;

  protected readonly statusLabel = getCancellationFlowHistoryLabel;

  protected readonly formatDate = formatDateTimeToFrCh;

  protected readonly describe = describeChange;

  openModal(row: CancellationRow): void {
    if (!this.template) return;
    this.row = row;
    this.modalService.open(this.template, { centered: true, size: 'lg' });
  }
}
